exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event-vertical-card-container.course__mask[data-v-60feb15b]{height:410px;min-height:410px}.company-course-card__body__lessons__day[data-v-60feb15b]{width:32px!important;height:32px!important;line-height:29px}.results-course-card__body__lessons__day--has-lesson[data-v-60feb15b]{border-color:#fd6e00!important;color:#fd6e00!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60feb15b","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/company/CompanyCourseCard.vue
// module id = fx1n
// module chunks = 36